// eslint-disable-next-line import/order
import "./polyfills";

import "@ant-design/v5-patch-for-react-19";
import { createRoot } from "react-dom/client";

import { App } from "./app";
import SchoolSDK from "./shared/lib/school-sdk";

window.AXLSchool = new SchoolSDK();

const container = document.getElementById("root");
if (container) {
  const root = createRoot(container);
  root.render(<App />);
}
